import clsx from "clsx";
import React, { forwardRef } from "react";
import { StyledBaseButton } from "./Button.style";

export const btnColor = {
  primary:
    "btn-primary shadow-content-box cursor-pointer text-white bg-gradient-to-tl from-vekin-primary to-vekin-tertiary border-vekin-primary/40 hover:from-vekin-primary hover:to-vekin-primary hover:border-vekin-primary",
  secondary:
    "btn-ghost shadow-content-box cursor-pointer bg-white text-vekin-green100 border border-quartenary hover:bg-vekin-green-50 hover:border hover:border-quartenary",
  tertiary:
    "btn-ghost shadow-content-box cursor-pointer text-vekin-green100 hover:bg-vekin-green-50",
};

export const btnSize = {
  "x-large":
    " !min-w-[3.125rem] !min-h-[3.125rem] h-[3.125rem] px-4 font-semibold text-base leading-[1.125rem] rounded",
  large:
    " !min-w-11 !min-h-[2.75rem] h-11 px-[0.875rem] font-semibold text-sm leading-4 rounded",
  normal:
    " !min-w-9 !min-h-[2.25rem] h-9 px-3 font-semibold text-xs leading-[0.875rem] rounded-lg",
  small:
    " !min-w-8 !min-h-[2rem] h-8 px-2 font-semibold text-[0.625rem] leading-[0.875rem] rounded-full",
  "x-small":
    " !min-w-6 !min-h-[1.5rem] h-6 px-2 font-semibold text-[0.5rem] leading-[0.875rem] rounded-full",
};

const BaseButton = forwardRef(
  ({ children, variant, size, className, ...props }, ref) => {
    const disabled = props.disabled;

    return (
      <StyledBaseButton
        ref={ref}
        className={clsx(
          btnColor[variant],
          btnSize[size],
          {
            "text-tertiary !cursor-default bg-gradient-to-tl !from-quartenary !to-quartenary !border !border-quartenary !shadow-none hover:from-quartenary hover:to-quartenary":
              disabled && variant !== "tertiary",
          },
          {
            "text-tertiary !cursor-default !bg-transparent hover:!bg-transparent !shadow-none":
              disabled && variant === "tertiary",
          },
          className
        )}
        {...props}
      >
        {children}
      </StyledBaseButton>
    );
  }
);

export default BaseButton;
